import { isAdmin, isAdminRead, isAdminReadRestricted, isAnyStratAdmin } from './services/rolesSvc';
import Program from './pages/Program';
import ProgramStrategy from './pages/ProgramStrategy';
import ProgramIndicators from './pages/ProgramIndicators';
import Indicators from './pages/Indicators';
import Policies from './pages/Policies';
import Docs from './pages/Docs';
import Model from './pages/Model';
import Projects from './pages/Projects';
import Calendar from './pages/Calendar';
import Consortiums from './pages/Consortiums';
import Indexes from './pages/Indexes';
import Admin from './pages/admin/Admin';
import AdminStrats from './pages/admin/AdminStrats';
import AdminFundings from './pages/admin/AdminFundings';
import AdminFundingsPlans from './pages/admin/AdminFundingsPlans';
import AdminExchange1S from './pages/admin/AdminExchange1S';
import StratProjectCreate from './pages/admin/StratProjectCreate';
import StratProjReport from './pages/StratProjReport';
import SPReport from './pages/SPReport';
import StratProject from './pages/stratProject/Profile/Project';
import ProjectPassport from './pages/project/Passport';
import Budget from './pages/budget/Budget';
import ProjectMembers from './pages/members/ProjectMembers';
import RegistryMembers from './pages/members/RegistryMembers';
import MasterBudget from './pages/reports/MasterBudget';
import BudgetReports from './pages/reports/BudgetReports';
import BudgetAccounting from './pages/reports/BudgetAccounting';
import BuyEditForm from './pages/budget/BuyEditForm';
import NewsRead from './pages/news/NewsRead';
import NewsEdit from './pages/news/NewsEdit';
import ExpenseTypes from './pages/admin/ExpenseTypes/ExpenseTypes';
import PortfolioIndexRouter from './pages/portfolio/IndexRouter';
import PortfolioPassportEditPage from './pages/portfolio/PassportEdit/Page';
import PortfolioProjectPassport from './pages/portfolio/PortfolioProject/Passport';

import NavItemProject from './components/navigation/NavItemProject';
import NavItemPolicy from './components/navigation/NavItemPolicy';
import PolicyProfilePage from './pages/policy/Profile/Page';
import PolicyProjectPassport from './pages/policy/PolicyProject/Passport';
import StratResultSubView from './components/strategyProject/tabs/TabResults/StratResultSubView';

import StratResultsEditView from './components/strategyProject/tabs/TabResults/StratResultsEditView';
import PortfolioProjectWidgets from './pages/PortfolioProjectWidgets';
import ArticleForm from './components/project/Widgets/Articles/ArticleForm';
import PortfolioWidgets from './pages/portfolio/PortfolioWidgets/PortfoioWidgetsWithUrls';
import PortfolioWidgetsPage from './pages/portfolio/PortfolioWidgets/PortfolioWidgetsPage';
import PortfRequests from './pages/portfolio/PortfolioWidgets/WidgetPages/PortfRequests';
import IncomesForm from './components/project/Widgets/Incomes/IncomesForm';
import PortfProjReportWidgetPage from './pages/project/PortfolioProject/PortfolioProjectWidgets';
import ProgramReports from './pages/programReports/ProgramReports';
import AdminSettings from './pages/admin/AdminSettings/AdminSettings';
import AdminIndexes from './pages/admin/Indexes/AdminIndexes';
import IndexCard from './pages/admin/Indexes/IndexCard';
import SPReportWidgetsWithPage from './components/SPReportTabs/SPReportWidgetsWithPage';
import ProjectReportWidgets from './components/project/ProjectReportWidgets';
import NavBarIndexes from './components/navigation/NavBarIndexes';
import IndexPage from "./components/Indexes/IndexesPage/IndexPage";
import CalculationUnifiedWidgets from "./components/Indexes/CalculationUnifiedWidgets";
import BaseDetailUnifiedPcs from "./components/Indexes/BaseDetailUnifiedPcs";
import BaseDetailUnifiedPcsByStratProj from "./components/Indexes/BaseDetailUnifiedPcsByStratProj";
import News from './pages/news/News';
import PoliciesReport from './pages/policy/PolicyProject/PoliciesReport';
import PoliciesWidgets from './pages/policy/PolicyProject/PoliciesWidgets';
import NioktrAddReceipt from './pages/budget/addReceiptForms/NioktrAddReceipt';
import NioktrEditReceipt from './pages/budget/editReceiptForms/NioktrEditReceipt';
import OwnFundsEditReceipt from './pages/budget/editReceiptForms/OwnFundsEditReceipt';
import Statistics from './pages/Statistics';
import AddIndexComponent from './pages/index/AddIndexComponent';
import AdminTags from './pages/admin/AdminTags';
import { NavItemGoal } from './components/navigation/NavItemGoal';
import { NavItemTech } from './components/navigation/NavItemTech';
import ProjectReport from './components/project/ProjectReport';
import ProjectWidgets from './components/project/ProjectWidgets';

const isNotAdmin = (userCtx) => !isAdmin(userCtx);
const isNotAdminOrSP = (userCtx) => !isAdminRead(userCtx) && !isAnyStratAdmin(userCtx);

export const navbarRoutes = [
  {
    title: 'О программе',
    id: 'about',
    path: '/about',
    component: Program,
    exact: true,
    subRoutes: [
      {
        title: 'Ключевые индикаторы программы', id: 'indicators', path: '/about/indicators', component: Indicators,
      },
    ],
  },
  {
    title: 'Новости', id: 'news', path: '/news', component: News, exact: true,
  },
  { title: 'Документы', id: 'docs', path: '/docs' },
  {
    title: 'Управление бюджетом',
    id: 'admin-budget',
    path: '/budget',
    exact: true,
    component: MasterBudget,
    hide: isNotAdminOrSP,
    subRoutes: [
      {
        title: 'Отчеты по бюджету', id: 'admin-budget-reports', path: '/budget/reports', component: BudgetReports, hide: isNotAdminOrSP,
      },
      {
        title: 'Оперативная комиссия', id: 'admin-budget-accounting', path: '/budget/accounting', component: BudgetAccounting, hide: isNotAdmin,
      },
    ],
  },
  {
    title: 'Отчет по программе', id: 'program-report', path: '/programreport', component: ProgramReports, exact: true, hide: (userCtx) => !isAdminReadRestricted(userCtx) && !userCtx.perms.includes('strategies'),
  },

  {
    title: 'Стратегические технологические проекты',
    id: 'techs',
    path: '/techs',
    exact: true,
    navItem: NavItemTech,
    component: Projects,
    subRoutes: [
      {
        title: 'Политика развития',
        id: 'techs-id',
        path: '/techs/:stratId',
        exact: true,
        component: StratProject,
        subRoutes: [
          {
            title: 'Цифровой паспорт СТП',
            id: 'techs-id-passport',
            path: '/techs/:stratId',
          },
          {
            title: 'Выдающиеся результаты', id: 'strat-id-results', path: '/techs/:stratId/results/new', component: StratResultSubView,
          },
          {
            title: 'Выдающиеся результаты', id: 'strat-id-results-edit', path: '/techs/:stratId/:resultId-:mileStoneId/edit', component: StratResultsEditView,
          },
          {
            title: 'Отчёт',
            id: 'techs-report',
            path: '/techs/:stratId/report',
            component: ProjectReport,
            exact: true,
            subRoutes: [
              {
                title: 'Виджеты СТП',
                id: 'techs-report-page',
                path: '/techs/:stratId/report/:type',
                exact: true,
                component: ProjectWidgets,
              },
            ]
          },
          {
            title: 'Участники',
            id: 'techs-id-members',
            path: '/techs/:stratId/members',
            component: RegistryMembers,
          },
          {
            title: 'Управление бюджетом',
            id: 'techs-id-budget',
            path: '/techs/:stratId/budget',
            exact: true,
            component: Budget,
            subRoutes: [
              {
                title: 'Добавление поступления',
                id: 'techs-budget-receipts-new-receipt',
                path: '/techs/:stratId/budget/nioktr-receipts/new-receipt',
                exact: true,
                component: NioktrAddReceipt,
              },
              {
                title: 'Редактирование поступления',
                id: 'techs-budget-receipts-edit-receipt',
                path: '/techs/:stratId/budget/nioktr-receipts/:receiptId/edit-receipt',
                exact: true,
                component: NioktrEditReceipt,
              },
              {
                title: 'Добавление/редактирование записи о собственных средствах',
                id: 'techs-budget-own-funds-edit-contract',
                path: '/techs/:techId/budget/nioktr-own-funds/:receiptId/edit-receipt',
                exact: true,
                component: OwnFundsEditReceipt,
              },
            ],
          },
        ],
      },
      {
        title: 'Проект',
        id: 'tech-projs-id',
        path: '/techs/:stratId/projs/:projId',
        exact: true,
        component: ProjectPassport,
        subRoutes: [
          { title: 'Цифровой паспорт', id: 'tech-projs-id-passport', path: '/techs/:stratId/projs/:projId' },
          {
            title: 'Отчет', id: 'tech-projs-id-report', path: '/techs/:stratId/projs/:projId/report', component: StratProjReport, exact: true, subRoutes: [
              { title: 'Ежегодный отчет (виджет)', id: 'tech-projs-id-widgets', path: '/techs/:stratId/projs/:projId/report/:type/:reportYear', exact: true, component: ProjectReportWidgets },
              { title: 'Виджеты проекта', id: 'tech-projs-id-unified', path: '/techs/:stratId/projs/:projId/report/:type', exact: true, component: ProjectReportWidgets },
              { title: 'Редактирование факта вехи (виджет)', id: 'tech-projs-id-milestones', path: '/techs/:stratId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: ProjectReportWidgets },
              { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/techs/:stratId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: ProjectReportWidgets },
              { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/techs/:stratId/projs/:projId/report/:type/new-contract', exact: true, component: ProjectReportWidgets },
            ]
          },
          {
            title: 'Участники',
            id: 'tech-projs-id-members',
            path: '/techs/:stratId/projs/:projId/members',
            component: ProjectMembers,
          },
          {
            title: 'Управление бюджетом',
            id: 'tech-projs-id-budget',
            path: "/techs/:stratId/projs/:projId/budget",
            component: Budget,
          },
        ],
      },
      {
        title: 'Портфель',
        id: 'portfolio-id',
        path: '/techs/:stratId/portfolios/:portfolioId',
        exact: true,
        component: PortfolioIndexRouter,
        subRoutes: [
          { title: 'Цифровой паспорт портфеля', id: 'portfolio-id-passport', path: '/techs/:stratId/portfolios/:portfolioId' },
          {
            title: 'Редактирование портфеля', id: 'portfolio-id-edit', path: '/techs/:stratId/portfolios/:portfolioId/edit', component: PortfolioPassportEditPage,
          },
          {
            title: 'Виджеты портфеля',
            id: 'portfolio-id-widgets',
            path: '/techs/:stratId/portfolios/:portfolioId/report',
            exact: true,
            component: PortfolioWidgets,
            subRoutes: [
              { title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/techs/:stratId/portfolios/:portfolioId/report/:type', exact: true, component: PortfolioWidgetsPage },
            ],
          },
          {
            title: 'Управление бюджетом', id: 'portfolio-id-budget', path: '/techs/:stratId/portfolios/:portfolioId/budget', component: Budget,
          },
          {
            title: 'Участники', id: 'portfolio-id-members', path: '/techs/:stratId/portfolios/:portfolioId/members', component: RegistryMembers,
          },
        ],
      },
      {
        title: 'Портфельный проект',
        id: 'portfolio-projs-id',
        path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId',
        exact: true,
        component: PortfolioProjectPassport,
        subRoutes: [
          {
            title: 'Отчет',
            id: 'portfolio-projs-id-report',
            path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report',
            component: PortfolioProjectWidgets,
            exact: true,
            subRoutes: [
              {
                title: 'Ежегодный отчет', id: 'portfolio-projs-id-report-year', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/yearReport', exact: true, component: StratProjReport,
                subRoutes: [
                  { title: 'Виджеты проекта', id: 'portfolio-projs-id-unified', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type/:reportYear', exact: true, component: ProjectReportWidgets },
                  { title: 'Виджеты проекта', id: 'portfolio-projs-id-report-page', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type', exact: true, component: ProjectReportWidgets },
                ]
              },
              {
                title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/:type', exact: true, component: PortfProjReportWidgetPage,
              },
              {
                title: 'Добавление/Редактирование статьи', id: 'portfolio-projs-id-operations-article', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/articles/:articleId', exact: true, component: ArticleForm,
              },
              {
                title: 'Добавление/Редактирование доходов', id: 'portfolio-projs-id-operations-income', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/income/:incomeId', exact: true, component: IncomesForm,
              },
              {
                title: 'Заявки', id: 'portfolio-projs-id-requsts', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/requests', exact: true, component: PortfRequests,
              },
              { title: 'Редактирование факта вехи (виджет)', id: 'projs-id-unified', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: PortfProjReportWidgetPage },
              { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: PortfProjReportWidgetPage },
              { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/new-contract', exact: true, component: PortfProjReportWidgetPage },
            ],
          },
          {
            title: 'Управление бюджетом', id: 'portfolio-projs-id-budget', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/budget', component: Budget,
          },
          {
            title: 'Участники', id: 'portfolio-projs-id-members', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/members', component: ProjectMembers,
          },
        ],
      },
      {
        title: 'Стратегические проекты (Архив до 2024)',
        id: 'strats',
        path: '/strats',
        exact: true,
        // navItem: NavItemProject, теперь все в NavItemTech
        component: Projects,
        subRoutes: [
          {
            title: 'Стратегический проект',
            id: 'strats-id',
            path: '/strats/:stratId',
            exact: true,
            component: StratProject,
            subRoutes: [
              { title: 'Цифровой паспорт СП', id: 'strats-id-passport', path: '/strats/:stratId' },
              {
                title: 'Выдающиеся результаты', id: 'strat-id-results', path: '/strats/:stratId/results/new', component: StratResultSubView,
              },
              {
                title: 'Выдающиеся результаты', id: 'strat-id-results-edit', path: '/strats/:stratId/:resultId-:mileStoneId/edit', component: StratResultsEditView,
              },
              {
                title: 'Отчет СП', id: 'strats-id-report', path: '/strats/:stratId/report', component: SPReport, exact: true,
                subRoutes: [
                  { title: 'Виджеты СП', id: 'strats-id-widgets-type', path: '/strats/:stratId/report/:type', component: SPReportWidgetsWithPage, exact: true }
                ]
              },
              {
                title: 'Управление бюджетом', id: 'strats-id-budget', path: '/strats/:stratId/budget', component: Budget,
              },
              {
                title: 'Участники СП', id: 'strats-id-members', path: '/strats/:stratId/members', component: RegistryMembers,
              },
            ],
          },
          {
            title: 'Проект',
            id: 'projs-id',
            path: '/strats/:stratId/projs/:projId',
            exact: true,
            component: ProjectPassport,
            subRoutes: [
              { title: 'Цифровой паспорт', id: 'projs-id-passport', path: '/strats/:stratId/projs/:projId' },
              {
                title: 'Отчет',
                id: 'projs-id-report',
                path: '/strats/:stratId/projs/:projId/report',
                component: StratProjReport,
                exact: true,
                subRoutes: [
                  { title: 'Ежегодный отчет (виджет)', id: 'projs-id-report-page', path: '/strats/:stratId/projs/:projId/report/:type/:reportYear', exact: true, component: ProjectReportWidgets },
                  { title: 'Виджеты проекта', id: 'projs-id-unified', path: '/strats/:stratId/projs/:projId/report/:type', exact: true, component: ProjectReportWidgets },
                  { title: 'Редактирование факта вехи (виджет)', id: 'projs-id-unified', path: '/strats/:stratId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: ProjectReportWidgets },
                  { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/strats/:stratId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: ProjectReportWidgets },
                  { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/strats/:stratId/projs/:projId/report/:type/new-contract', exact: true, component: ProjectReportWidgets },
                ]
              },
              {
                title: 'Управление бюджетом', id: 'projs-id-budget', path: '/strats/:stratId/projs/:projId/budget', component: Budget,
              },
              {
                title: 'Участники', id: 'projs-id-members', path: '/strats/:stratId/projs/:projId/members', component: ProjectMembers,
              },
            ],
          },
          {
            title: 'Портфель',
            id: 'portfolio-id',
            path: '/strats/:stratId/portfolios/:portfolioId',
            exact: true,
            component: PortfolioIndexRouter,
            subRoutes: [
              { title: 'Цифровой паспорт портфеля', id: 'portfolio-id-passport', path: '/strats/:stratId/portfolios/:portfolioId' },
              {
                title: 'Редактирование портфеля', id: 'portfolio-id-edit', path: '/strats/:stratId/portfolios/:portfolioId/edit', component: PortfolioPassportEditPage,
              },
              {
                title: 'Виджеты портфеля',
                id: 'portfolio-id-widgets',
                path: '/strats/:stratId/portfolios/:portfolioId/report',
                exact: true,
                component: PortfolioWidgets,
                subRoutes: [
                  { title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/strats/:stratId/portfolios/:portfolioId/report/:type', exact: true, component: PortfolioWidgetsPage },
                ],
              },
              {
                title: 'Управление бюджетом', id: 'portfolio-id-budget', path: '/strats/:stratId/portfolios/:portfolioId/budget', component: Budget,
              },
              {
                title: 'Участники', id: 'portfolio-id-members', path: '/strats/:stratId/portfolios/:portfolioId/members', component: RegistryMembers,
              },
            ],
          },
          {
            title: 'Портфельный проект',
            id: 'portfolio-projs-id',
            path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId',
            exact: true,
            component: PortfolioProjectPassport,
            subRoutes: [
              {
                title: 'Отчет',
                id: 'portfolio-projs-id-report',
                path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report',
                component: PortfolioProjectWidgets,
                exact: true,
                subRoutes: [
                  {
                    title: 'Ежегодный отчет', id: 'portfolio-projs-id-report-year', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/yearReport', exact: true, component: StratProjReport,
                    subRoutes: [
                      { title: 'Виджеты проекта', id: 'portfolio-projs-id-unified', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type/:reportYear', exact: true, component: ProjectReportWidgets },
                      { title: 'Виджеты проекта', id: 'portfolio-projs-id-report-page', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type', exact: true, component: ProjectReportWidgets },
                    ]
                  },
                  {
                    title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/:type', exact: true, component: PortfProjReportWidgetPage,
                  },
                  {
                    title: 'Добавление/Редактирование статьи', id: 'portfolio-projs-id-operations-article', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/articles/:articleId', exact: true, component: ArticleForm,
                  },
                  {
                    title: 'Добавление/Редактирование доходов', id: 'portfolio-projs-id-operations-income', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/income/:incomeId', exact: true, component: IncomesForm,
                  },
                  {
                    title: 'Заявки', id: 'portfolio-projs-id-requsts', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/requests', exact: true, component: PortfRequests,
                  },
                  { title: 'Редактирование факта вехи (виджет)', id: 'projs-id-unified', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: PortfProjReportWidgetPage },
                  { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: PortfProjReportWidgetPage },
                  { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/new-contract', exact: true, component: PortfProjReportWidgetPage },
                ],
              },
              {
                title: 'Управление бюджетом', id: 'portfolio-projs-id-budget', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/budget', component: Budget,
              },
              {
                title: 'Участники', id: 'portfolio-projs-id-members', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/members', component: ProjectMembers,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Стратегические цели университета',
    id: 'goals',
    path: '/goals',
    exact: true,
    navItem: NavItemGoal,
    component: Projects,
    subRoutes: [
      {
        title: 'Политика развития',
        id: 'goals-id',
        path: '/goals/:stratId',
        exact: true,
        component: StratProject,
        subRoutes: [
          {
            title: 'Цифровой паспорт цели',
            id: 'goals-id-passport',
            path: '/goals/:stratId',
          },
          {
            title: 'Выдающиеся результаты', id: 'strat-id-results', path: '/goals/:stratId/results/new', component: StratResultSubView,
          },
          {
            title: 'Выдающиеся результаты', id: 'strat-id-results-edit', path: '/goals/:stratId/:resultId-:mileStoneId/edit', component: StratResultsEditView,
          },
          {
            title: 'Отчёт',
            id: 'goals-report',
            path: '/goals/:stratId/report',
            component: ProjectReport,
            exact: true,
            subRoutes: [
              {
                title: 'Виджеты цели',
                id: 'goals-report-page',
                path: '/goals/:stratId/report/:type',
                exact: true,
                component: ProjectWidgets,
              },
            ]
          },
          {
            title: 'Участники',
            id: 'goals-id-members',
            path: '/goals/:stratId/members',
            component: RegistryMembers,
          },
          {
            title: 'Управление бюджетом',
            id: 'goals-id-budget',
            path: '/goals/:stratId/budget',
            exact: true,
            component: Budget,
            subRoutes: [
              {
                title: 'Добавление поступления',
                id: 'goals-budget-receipts-new-receipt',
                path: '/goals/:stratId/budget/nioktr-receipts/new-receipt',
                exact: true,
                component: NioktrAddReceipt,
              },
              {
                title: 'Редактирование поступления',
                id: 'goals-budget-receipts-edit-receipt',
                path: '/goals/:stratId/budget/nioktr-receipts/:receiptId/edit-receipt',
                exact: true,
                component: NioktrEditReceipt,
              },
              {
                title: 'Добавление/редактирование записи о собственных средствах',
                id: 'goals-budget-own-funds-edit-contract',
                path: '/goals/:goalId/budget/nioktr-own-funds/:receiptId/edit-receipt',
                exact: true,
                component: OwnFundsEditReceipt,
              },
            ],
          },
        ],
      },
      {
        title: 'Проект',
        id: 'goal-projs-id',
        path: '/goals/:stratId/projs/:projId',
        exact: true,
        component: ProjectPassport,
        subRoutes: [
          { title: 'Цифровой паспорт', id: 'goal-projs-id-passport', path: '/goals/:stratId/projs/:projId' },
          {
            title: 'Отчет', id: 'goal-projs-id-report', path: '/goals/:stratId/projs/:projId/report', component: StratProjReport, exact: true, subRoutes: [
              { title: 'Ежегодный отчет (виджет)', id: 'goal-projs-id-widgets', path: '/goals/:stratId/projs/:projId/report/:type/:reportYear', exact: true, component: ProjectReportWidgets },
              { title: 'Виджеты проекта', id: 'goal-projs-id-unified', path: '/goals/:stratId/projs/:projId/report/:type', exact: true, component: ProjectReportWidgets },
              { title: 'Редактирование факта вехи (виджет)', id: 'goal-projs-id-milestones', path: '/goals/:stratId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: ProjectReportWidgets },
              { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/goals/:stratId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: ProjectReportWidgets },
              { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/goals/:stratId/projs/:projId/report/:type/new-contract', exact: true, component: ProjectReportWidgets },
            ]
          },
          {
            title: 'Участники',
            id: 'goal-projs-id-members',
            path: '/goals/:stratId/projs/:projId/members',
            component: ProjectMembers,
          },
          {
            title: 'Управление бюджетом',
            id: 'goal-projs-id-budget',
            path: "/goals/:stratId/projs/:projId/budget",
            component: Budget,
          },
        ],
      },
      {
        title: 'Портфель',
        id: 'portfolio-id',
        path: '/goals/:stratId/portfolios/:portfolioId',
        exact: true,
        component: PortfolioIndexRouter,
        subRoutes: [
          { title: 'Цифровой паспорт портфеля', id: 'portfolio-id-passport', path: '/goals/:stratId/portfolios/:portfolioId' },
          {
            title: 'Редактирование портфеля', id: 'portfolio-id-edit', path: '/goals/:stratId/portfolios/:portfolioId/edit', component: PortfolioPassportEditPage,
          },
          {
            title: 'Виджеты портфеля',
            id: 'portfolio-id-widgets',
            path: '/goals/:stratId/portfolios/:portfolioId/report',
            exact: true,
            component: PortfolioWidgets,
            subRoutes: [
              { title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/goals/:stratId/portfolios/:portfolioId/report/:type', exact: true, component: PortfolioWidgetsPage },
            ],
          },
          {
            title: 'Управление бюджетом', id: 'portfolio-id-budget', path: '/goals/:stratId/portfolios/:portfolioId/budget', component: Budget,
          },
          {
            title: 'Участники', id: 'portfolio-id-members', path: '/goals/:stratId/portfolios/:portfolioId/members', component: RegistryMembers,
          },
        ],
      },
      {
        title: 'Портфельный проект',
        id: 'portfolio-projs-id',
        path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId',
        exact: true,
        component: PortfolioProjectPassport,
        subRoutes: [
          {
            title: 'Отчет',
            id: 'portfolio-projs-id-report',
            path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report',
            component: PortfolioProjectWidgets,
            exact: true,
            subRoutes: [
              {
                title: 'Ежегодный отчет', id: 'portfolio-projs-id-report-year', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/yearReport', exact: true, component: StratProjReport,
                subRoutes: [
                  { title: 'Виджеты проекта', id: 'portfolio-projs-id-unified', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type/:reportYear', exact: true, component: ProjectReportWidgets },
                  { title: 'Виджеты проекта', id: 'portfolio-projs-id-report-page', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type', exact: true, component: ProjectReportWidgets },
                ]
              },
              {
                title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/:type', exact: true, component: PortfProjReportWidgetPage,
              },
              {
                title: 'Добавление/Редактирование статьи', id: 'portfolio-projs-id-operations-article', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/articles/:articleId', exact: true, component: ArticleForm,
              },
              {
                title: 'Добавление/Редактирование доходов', id: 'portfolio-projs-id-operations-income', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/income/:incomeId', exact: true, component: IncomesForm,
              },
              {
                title: 'Заявки', id: 'portfolio-projs-id-requsts', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/requests', exact: true, component: PortfRequests,
              },
              { title: 'Редактирование факта вехи (виджет)', id: 'projs-id-unified', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: PortfProjReportWidgetPage },
              { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: PortfProjReportWidgetPage },
              { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/new-contract', exact: true, component: PortfProjReportWidgetPage },
            ],
          },
          {
            title: 'Управление бюджетом', id: 'portfolio-projs-id-budget', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/budget', component: Budget,
          },
          {
            title: 'Участники', id: 'portfolio-projs-id-members', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/members', component: ProjectMembers,
          },
        ],
      },
    ],
  },
  {
    title: 'Политики развития',
    id: 'policies',
    path: '/policies',
    exact: true,
    navItem: NavItemPolicy,
    component: Projects,
    subRoutes: [
      {
        title: 'Политики (Архив до 2024)',
        id: 'policies-archive',
        path: '/policies/archive',
        exact: true,
        component: Projects,
        subRoutes: [
          {
            title: 'Политика развития',
            id: 'policies-archive-id',
            path: '/policies/archive/:stratId',
            exact: true,
            component: PolicyProfilePage,
            subRoutes: [
              {
                title: 'Цифровой паспорт политики',
                id: 'policies-archive-id-passport',
                path: '/policies/archive/:stratId',
              },
              {
                title: 'Отчёт',
                id: 'policies-archive-report',
                path: '/policies/archive/:stratId/report',
                component: PoliciesReport,
                exact: true,
                subRoutes: [
                  {
                    title: 'Виджеты политики',
                    id: 'policies-archive-report-page',
                    path:'/policies/archive/:stratId/report/:type',
                    exact: true,
                    component: PoliciesWidgets,
                  },
                ]
              },
              {
                title: 'Участники',
                id: 'policies-archive-id-members',
                path: '/policies/archive/:stratId/members',
                component: RegistryMembers,
              },
              {
                title: 'Управление бюджетом',
                id: 'policies-archive-id-budget',
                path: '/policies/archive/:stratId/budget',
                exact: true,
                component: Budget,
                subRoutes: [
                  {
                    title: 'Добавление поступления',
                    id: 'policies-archive-budget-receipts-new-receipt',
                    path: '/policies/archive/:stratId/budget/nioktr-receipts/new-receipt',
                    exact: true,
                    component: NioktrAddReceipt,
                  },
                  {
                    title: 'Редактирование поступления',
                    id: 'policies-archive-budget-receipts-edit-receipt',
                    path: '/policies/archive/:stratId/budget/nioktr-receipts/:receiptId/edit-receipt',
                    exact: true,
                    component: NioktrEditReceipt,
                  },
                  {
                    title: 'Добавление/редактирование записи о собственных средствах',
                    id: 'policies-archive-budget-own-funds-edit-contract',
                    path:'/policies/archive/:stratId/budget/nioktr-own-funds/:receiptId/edit-receipt',
                    exact: true,
                    component: OwnFundsEditReceipt,
                  },
                ],
              },
            ],
          },
          {
            title: 'Проект',
            id: 'policy-archive-projs-id',
            path: '/policies/archive/:stratId/projs/:projId',
            exact: true,
            component: PolicyProjectPassport,
            subRoutes: [
              { title: 'Цифровой паспорт', id: 'policy-archive-projs-id-passport', path: '/policies/archive/:stratId/projs/:projId' },
              {
                title: 'Отчет', id: 'policy-archive-projs-id-report', path: '/policies/archive/:stratId/projs/:projId/report', component: StratProjReport, exact: true, subRoutes: [
                  { title: 'Ежегодный отчет (виджет)', id: 'policy-archive-projs-id-widgets', path: '/policies/archive/:stratId/projs/:projId/report/:type/:reportYear', exact: true, component: ProjectReportWidgets },
                  { title: 'Виджеты проекта', id: 'policy-archive-projs-id-unified', path: '/policies/archive/:stratId/projs/:projId/report/:type', exact: true, component: ProjectReportWidgets },
                  { title: 'Редактирование факта вехи (виджет)', id: 'policy-archive-projs-id-milestones',path:'/policies/archive/:stratId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: ProjectReportWidgets },
                ]
              },
              {
                title: 'Участники',
                id: 'policy-archive-projs-id-members',
                path: '/policies/archive/:stratId/projs/:projId/members',
                component: ProjectMembers,
              },
              {
                title: 'Управление бюджетом',
                id: 'policy-archive-projs-id-budget',
                path: "/policies/archive/:stratId/projs/:projId/budget",
                component: Budget,
              },
            ],
          },
        ],
      },
      {
        title: 'Политика развития',
        id: 'policies-id',
        path: '/policies/:stratId',
        exact: true,
        component: StratProject,
        subRoutes: [
          {
            title: 'Цифровой паспорт политики',
            id: 'policies-id-passport',
            path: '/policies/:stratId',
          },
          {
            title: 'Выдающиеся результаты', id: 'strat-id-results', path: '/policies/:stratId/results/new', component: StratResultSubView,
          },
          {
            title: 'Выдающиеся результаты', id: 'strat-id-results-edit', path: '/policies/:stratId/:resultId-:mileStoneId/edit', component: StratResultsEditView,
          },
          {
            title: 'Отчёт',
            id: 'policies-report',
            path: '/policies/:stratId/report',
            component: ProjectReport,
            exact: true,
            subRoutes: [
              {
                title: 'Виджеты политики',
                id: 'policies-report-page',
                path: '/policies/:stratId/report/:type',
                exact: true,
                component: ProjectWidgets,
              },
            ]
          },
          {
            title: 'Участники',
            id: 'policies-id-members',
            path: '/policies/:stratId/members',
            component: RegistryMembers,
          },
          {
            title: 'Управление бюджетом',
            id: 'policies-id-budget',
            path: '/policies/:stratId/budget',
            exact: true,
            component: Budget,
            subRoutes: [
              {
                title: 'Добавление поступления',
                id: 'policies-budget-receipts-new-receipt',
                path: '/policies/:stratId/budget/nioktr-receipts/new-receipt',
                exact: true,
                component: NioktrAddReceipt,
              },
              {
                title: 'Редактирование поступления',
                id: 'policies-budget-receipts-edit-receipt',
                path: '/policies/:stratId/budget/nioktr-receipts/:receiptId/edit-receipt',
                exact: true,
                component: NioktrEditReceipt,
              },
              {
                title: 'Добавление/редактирование записи о собственных средствах',
                id: 'policies-budget-own-funds-edit-contract',
                path: '/policies/:policyId/budget/nioktr-own-funds/:receiptId/edit-receipt',
                exact: true,
                component: OwnFundsEditReceipt,
              },
            ],
          },
        ],
      },
      {
        title: 'Проект',
        id: 'policy-projs-id',
        path: '/policies/:stratId/projs/:projId',
        exact: true,
        component: ProjectPassport,
        subRoutes: [
          { title: 'Цифровой паспорт', id: 'policy-projs-id-passport', path: '/policies/:stratId/projs/:projId' },
          {
            title: 'Отчет', id: 'policy-projs-id-report', path: '/policies/:stratId/projs/:projId/report', component: StratProjReport, exact: true, subRoutes: [
              { title: 'Ежегодный отчет (виджет)', id: 'policy-projs-id-widgets', path: '/policies/:stratId/projs/:projId/report/:type/:reportYear', exact: true, component: ProjectReportWidgets },
              { title: 'Виджеты проекта', id: 'policy-projs-id-unified', path: '/policies/:stratId/projs/:projId/report/:type', exact: true, component: ProjectReportWidgets },
              { title: 'Редактирование факта вехи (виджет)', id: 'policy-projs-id-milestones', path: '/policies/:stratId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: ProjectReportWidgets },
              { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/policies/:stratId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: ProjectReportWidgets },
              { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/policies/:stratId/projs/:projId/report/:type/new-contract', exact: true, component: ProjectReportWidgets },
            ]
          },
          {
            title: 'Участники',
            id: 'policy-projs-id-members',
            path: '/policies/:stratId/projs/:projId/members',
            component: ProjectMembers,
          },
          {
            title: 'Управление бюджетом',
            id: 'policy-projs-id-budget',
            path: "/policies/:stratId/projs/:projId/budget",
            component: Budget,
          },
        ],
      },
      {
        title: 'Портфель',
        id: 'portfolio-id',
        path: '/policies/:stratId/portfolios/:portfolioId',
        exact: true,
        component: PortfolioIndexRouter,
        subRoutes: [
          { title: 'Цифровой паспорт портфеля', id: 'portfolio-id-passport', path: '/policies/:stratId/portfolios/:portfolioId' },
          {
            title: 'Редактирование портфеля', id: 'portfolio-id-edit', path: '/policies/:stratId/portfolios/:portfolioId/edit', component: PortfolioPassportEditPage,
          },
          {
            title: 'Виджеты портфеля',
            id: 'portfolio-id-widgets',
            path: '/policies/:stratId/portfolios/:portfolioId/report',
            exact: true,
            component: PortfolioWidgets,
            subRoutes: [
              { title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/policies/:stratId/portfolios/:portfolioId/report/:type', exact: true, component: PortfolioWidgetsPage },
            ],
          },
          {
            title: 'Управление бюджетом', id: 'portfolio-id-budget', path: '/policies/:stratId/portfolios/:portfolioId/budget', component: Budget,
          },
          {
            title: 'Участники', id: 'portfolio-id-members', path: '/policies/:stratId/portfolios/:portfolioId/members', component: RegistryMembers,
          },
        ],
      },
      {
        title: 'Портфельный проект',
        id: 'portfolio-projs-id',
        path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId',
        exact: true,
        component: PortfolioProjectPassport,
        subRoutes: [
          {
            title: 'Отчет',
            id: 'portfolio-projs-id-report',
            path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report',
            component: PortfolioProjectWidgets,
            exact: true,
            subRoutes: [
              {
                title: 'Ежегодный отчет', id: 'portfolio-projs-id-report-year', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/yearReport', exact: true, component: StratProjReport,
                subRoutes: [
                  { title: 'Виджеты проекта', id: 'portfolio-projs-id-unified', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type/:reportYear', exact: true, component: ProjectReportWidgets },
                  { title: 'Виджеты проекта', id: 'portfolio-projs-id-report-page', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/yearReport/:type', exact: true, component: ProjectReportWidgets },
                ]
              },
              {
                title: 'Проектные виджеты портфеля', id: 'portfolio-projs-id-widgets', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/:type', exact: true, component: PortfProjReportWidgetPage,
              },
              {
                title: 'Добавление/Редактирование статьи', id: 'portfolio-projs-id-operations-article', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/articles/:articleId', exact: true, component: ArticleForm,
              },
              {
                title: 'Добавление/Редактирование доходов', id: 'portfolio-projs-id-operations-income', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/income/:incomeId', exact: true, component: IncomesForm,
              },
              {
                title: 'Заявки', id: 'portfolio-projs-id-requsts', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/requests', exact: true, component: PortfRequests,
              },
              { title: 'Редактирование факта вехи (виджет)', id: 'projs-id-unified', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:milestoneId/edit', exact: true, component: PortfProjReportWidgetPage },
              { title: 'Редактирование поступления (виджет)', id: 'projs-id-unified', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/:receiptId/receipt-edit', exact: true, component: PortfProjReportWidgetPage },
              { title: 'Добавление поступления (виджет)', id: 'projs-id-unified', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/report/:type/new-contract', exact: true, component: PortfProjReportWidgetPage },
            ],
          },
          {
            title: 'Управление бюджетом', id: 'portfolio-projs-id-budget', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/budget', component: Budget,
          },
          {
            title: 'Участники', id: 'portfolio-projs-id-members', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/members', component: ProjectMembers,
          },
        ],
      },
    ],
  },
  {
    title: 'Показатели', id: 'indexes', exact: true, path: '/indexes', navItem: NavBarIndexes, component: Indexes, subRoutes: [
      {
        id: `index-widgets`,
        path: '/indexes/:type',
        exact: true,
        component: IndexPage,
        subRoutes: [
          {
            id: 'calculation-unified-part',
            path: '/indexes/calculation-unified-part/:type',
            component: CalculationUnifiedWidgets,
            exact: true,
          },
        ]
      },
      {
        id: 'add-index-component',
        path: '/indexes/add/:type',
        component: AddIndexComponent,
        exact: true,
      },
      {
        id: 'edit-index-component',
        path: '/indexes/add/:type/:id',
        component: AddIndexComponent,
        exact: true,
      }
    ]
  },
  {
    title: 'Консорциумы', id: 'consortiums', path: '/consortiums', component: Consortiums,
  },
  {
    title: 'Администрирование',
    id: 'admin',
    path: '/admin',
    exact: true,
    component: Admin,
    hide: isNotAdmin,
    subRoutes:
      [
        {
          title: 'Реестр объектов Программы', id: 'admin-strats', path: '/admin/strats', subSubtitle: true, component: AdminStrats, hide: isNotAdmin,
        },
        {
          title: 'Источники финансирования', id: 'admin-fundings', path: '/admin/fundings', component: AdminFundings, hide: isNotAdmin,
        },
        {
          title: 'Планы по источникам финансирования', id: 'admin-fundings-plans', path: '/admin/fundings-plans', component: AdminFundingsPlans, hide: isNotAdmin,
        },
        {
          title: 'Журнал обмена с 1С', id: 'admin-exchange-1s', path: '/admin/exchange-1s', component: AdminExchange1S, hide: isNotAdmin,
        },
        {
          title: 'Соответствие видов расходов КВР', id: 'admin-expense-types', path: '/admin/expense-types', component: ExpenseTypes, hide: isNotAdmin,
        },
        {
          title: 'Управление отчетными периодами', id: 'admin-settings', path: '/admin/settings', component: AdminSettings, hide: isNotAdmin,
        },
        {
          title: 'Реестр показателей проектов', id: 'admin-indexes', path: '/admin/indexes', component: AdminIndexes, hide: isNotAdmin, exact: true,
        },
        {
          title: 'Справочник тегов', id: 'admin-tags', path: '/admin/tags', hide: isNotAdmin, component: AdminTags
        }
      ],
  },
];

export const hiddenRoutes = [
  {
    id: 'root', path: '/', redirect: '/news', exact: true,
  },
  {
    title: 'Просмотр новости', id: 'news-read', path: '/news/read/:id', component: NewsRead,
  },
  {
    title: 'Редактирование новости', id: 'news-edit', path: '/news/edit/:id', component: NewsEdit,
  },
  {
    title: 'Целевая модель', id: 'model', path: '/model', component: Model,
  },
  {
    title: 'Документы', id: 'docs-folder', path: '/docs/:folderId?', component: Docs,
  },
  // {title: "Карточка проекта", path: "/project-passport", component: ProjectCreate, hideMenu: (perms) => !isAdmin(perms)},
  // {title: "Цифровой паспорт", id: "project-passport", path: "/project-passport", component: ProjectCreate},
  // {title: "Отчет", id: "project-report", path: "/project-report", component: StratProjReport},
  // {title: "Отчет СП", id: "sp-report", path: "/sp-report", component: SPReport},
  {
    title: 'Карточка стратегического проекта', id: 'sp-create', path: '/strat-proj-create', component: StratProjectCreate,
  },
  {
    title: 'Календарь', id: 'calendar', path: '/calendar', component: Calendar,
  },
  {
    title: 'Редактирование закупки', id: 'buys-id', path: '/strats/:stratId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-portfolio-id', path: '/strats/:stratId/portfolios/:portfolioId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-policy-id', path: '/policies/:stratId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-policy-id', path: '/policies/:stratId/portfolios/:portfolioId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-goal-id', path: '/goals/:stratId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-goal-id', path: '/goals/:stratId/portfolios/:portfolioId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-tech-id', path: '/techs/:stratId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Редактирование закупки', id: 'buys-tech-id', path: '/techs/:stratId/portfolios/:portfolioId/projs/:projId/buys/:buyId', component: BuyEditForm,
  },
  {
    title: 'Унифицированный показатель', id: 'admin-indexes-id', path: '/admin/indexes/:id', component: IndexCard,
  },
  {
    title: 'Реестр унифицированного показателя',
    id: 'unified-index-by-entity',
    path: '/indexes/unified-part/:countEntity',
    component: BaseDetailUnifiedPcs,
    exact: true,
  },
  {
    title: 'Реестр унифицированного показателя на уровне СП',
    id: 'unified-index-by-entity-and-strat-proj',
    path: '/indexes/unified-part/:countEntity/strats/:stratId',
    component: BaseDetailUnifiedPcsByStratProj,
    exact: true,
  },
  {
    title: 'Стратегия УрФУ в области технологического лидерства', id: 'about_strategy', path: '/about/strategy', component: ProgramStrategy
  },
  {
    title: 'Целевые показатели эффективности реализации программы развития УрФУ', id: 'about_pindicators', path: '/about/pindicators', component: ProgramIndicators
  }
];
